<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
  [name]="name"
  [fullScreen]="fullScreen"
>
  <p style="color: white">Loading...</p>
</ngx-spinner>
